class UserConstants {
	static LIMITED_ACCOUNT = 1;
	static PAYTREN_ACCOUNT = 2;
}

export default UserConstants



// WEBPACK FOOTER //
// ./src/components/User/Constants.js